import { useEffect, useMemo } from "react";
import { motion } from "framer-motion";
import { useNavigate, useSearchParams } from "react-router-dom";
import PlansSelectionView from "../../components/PlansSelectionView";
import {
  completeStripeCheckoutReturn,
  hasStripeCheckoutReturn,
} from "../../utils/stripeCheckoutReturn";
import styles from "./styles.module.css";

function PlansPage({ welcomePage = false, fastPublishing = false, setStep }) {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  const returnUrl = useMemo(() => {
    const url = new URL(window.location.href);
    url.searchParams.delete("session_id");
    url.searchParams.delete("isPaymentSuccess");
    return url.toString();
  }, []);

  const handlePlanSelectionSuccess = () => {
    if (welcomePage) {
      navigate("/StepsPage", {
        state: { fastPublication: true },
      });
      return;
    }

    if (fastPublishing) {
      navigate("/NewPublicationPageIA");
      return;
    }

    window.location.href = '/ChatSocket';
  };

  const handleSelectFreePlan = () => {
    if (welcomePage) {
      navigate("/StepsPage", {
        state: { fastPublication: true },
      });
      return;
    }

    if (fastPublishing) {
      navigate("/ChatSocket");
      return;
    }

    if (typeof setStep === "function") {
      setStep("stepNIcheAndObjective");
      return;
    }

    navigate("/PlanCheckoutUser");
  };

  useEffect(() => {
    if (!hasStripeCheckoutReturn(searchParams.toString())) return;

    const handleCheckoutSuccess = async () => {
      const sessionId = searchParams.get("session_id");
      await completeStripeCheckoutReturn(sessionId || undefined);
      handlePlanSelectionSuccess();
    };

    handleCheckoutSuccess();
  }, [searchParams]);

  return (
    <motion.div
      initial={{ opacity: 0 }}
      transition={{ duration: 0.3 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      className={styles.page}
    >
      <PlansSelectionView
        showCancelAccount={!welcomePage && !fastPublishing}
        showBackButton={!welcomePage && !fastPublishing}
        returnUrl={returnUrl}
        onSuccess={handlePlanSelectionSuccess}
        onSelectFreePlan={handleSelectFreePlan}
        allowCurrentPlanSelection={welcomePage || fastPublishing}
      />
    </motion.div>
  );
}

export default PlansPage;
